import { TrackerObjectiveValueTypes } from 'constants/assignments';

import {
  CHECK_ICON_MAPPER,
  MASTERY_LEVELS
} from 'pages/Teachers/ClassroomInsights/constants';
import {
  GENERAL_CONCEPTUAL_UNDERSTANDING,
  SIGNIFICANT_ERRORS_IN_WORK,
  WORK_IS_COMPLETE_AND_CORRECT
} from 'pages/Teachers/Insights/constants';
import {
  getShortPerformanceRubricLabel,
  getSortCheckboxRubricValue
} from 'utils/trackers';

export const getStatusFlags = ({
  status,
  masteryLabel,
  isPartialUpload,
  isPublished
}) => {
  const isPendingUpload =
    status === MASTERY_LEVELS.PENDING_UPLOAD || status === 'Pending Upload';
  const isNeedsReview =
    status === MASTERY_LEVELS.NEEDS_REVIEW ||
    status === 'Reupload Needed' ||
    status === 'Needs Review';

  const isCelebrate =
    masteryLabel === WORK_IS_COMPLETE_AND_CORRECT ||
    status === MASTERY_LEVELS.COMPLETE ||
    status === 'Celebrate';

  const isSupport =
    masteryLabel === GENERAL_CONCEPTUAL_UNDERSTANDING ||
    status === MASTERY_LEVELS.CONCEPTUAL ||
    status === 'Support';

  const isIntervene =
    masteryLabel === SIGNIFICANT_ERRORS_IN_WORK ||
    status === MASTERY_LEVELS.SIGNIFICANT_ERRORS ||
    status === 'Intervene';

  return {
    isPartialUpload,
    isPendingUpload,
    isNeedsReview,
    isCelebrate,
    isSupport,
    isIntervene,
    showStatusPill: isPartialUpload || isPendingUpload || isNeedsReview,
    showCheckIcon: isPublished
  };
};

export const getFormattedGrade = ({ grade, valueType }) => {
  if (valueType === TrackerObjectiveValueTypes.PERFORMANCE) {
    return getShortPerformanceRubricLabel({ rawValue: grade });
  }
  if (valueType === TrackerObjectiveValueTypes.CHECKBOX) {
    return getSortCheckboxRubricValue({ value: grade });
  }
  return grade;
};

export const renderCheckIcon = ({ isCelebrate, isSupport, isIntervene }) => {
  if (isCelebrate) return CHECK_ICON_MAPPER[MASTERY_LEVELS.CELEBRATE];
  if (isSupport) return CHECK_ICON_MAPPER[MASTERY_LEVELS.SUPPORT];
  if (isIntervene) return CHECK_ICON_MAPPER[MASTERY_LEVELS.INTERVENE];
  return null;
};
